import { render } from "./CoalViewMine.vue?vue&type=template&id=bed03eae"
import script from "./CoalViewMine.vue?vue&type=script&lang=js"
export * from "./CoalViewMine.vue?vue&type=script&lang=js"

import exportComponent from "/home/aisqwe/Documents/zev/kadena-projects/coal/my-vue-app1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__